module.exports = __webpack_public_path__ + "img/dokku.6416f96b.png";